(function () {
  "use strict";

  const currency = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function imageUrl(url, width) {
    if (!url || !width) return url || "";
    return String(url).replace(/(\.(?:jpg|jpeg|png|webp))(?:\?v=|$)/i, `_${width}x$1?v=`);
  }

  function state(product) {
    if (product.available) return "available";
    if (product.preorder) return "preorder";
    return "soldout";
  }

  function stateLabel(product) {
    if (product.available) return "Verfügbar";
    if (product.preorder) return "Vorbesteller";
    return "Ausverkauft";
  }

  function timeValue(value) {
    const parsed = Date.parse(value || "");
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function promoBadgesMarkup(product) {
    const createdAt = timeValue(product.created_at);
    const isNew = createdAt > 0 && Date.now() - createdAt < 86400000;
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at || 0);
    const badges = [];
    if (isNew) badges.push('<span class="genki-showcase-card__promo genki-showcase-card__promo--new">NEW</span>');
    if (product.sale || (compareAt > price && price > 0)) {
      badges.push('<span class="genki-showcase-card__promo genki-showcase-card__promo--sale">SALE</span>');
    }
    return badges.length ? `<span class="genki-showcase-card__promos">${badges.join("")}</span>` : "";
  }

  function releaseInfoMarkup(product) {
    const releaseDate = String(product.release_date || "").trim();
    if (!product.preorder || !releaseDate) return "";
    return `<div class="genki-showcase-card__release-info">
      <span>${product.release_changed ? "Neuer Termin" : "Release"}</span>
      <strong>${escapeHtml(releaseDate)}</strong>
    </div>`;
  }

  function priceMarkup(product) {
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at || 0);
    if (price <= 0) return "";
    const prefix = product.price_varies || Number(product._genkiFamilyCount || 1) > 1 ? "Jetzt ab" : "Jetzt";
    if (compareAt > price) {
      return `<div class="genki-showcase-card__price genki-showcase-card__price--sale">
        <strong>${prefix} ${currency.format(price)}</strong>
        <span>Vorher ${currency.format(compareAt)}</span>
      </div>`;
    }
    return `<div class="genki-showcase-card__price"><strong>${prefix} ${currency.format(price)}</strong></div>`;
  }

  function actionLabel(product) {
    if (product.preorder) return "Vorbestellen";
    if (product.available) return "In den Korb";
    return "Ansehen";
  }

  function renderCard(product, index) {
    const productState = state(product);
    const image = product.image
      ? `<img class="genki-showcase-card__image" src="${escapeHtml(imageUrl(product.image, 420))}" alt="${escapeHtml(product.title)}" loading="${index < 4 ? "eager" : "lazy"}" decoding="async">`
      : "";
    return `<li class="genki-showcase-card genki-showcase-card--${productState}">
      <a class="genki-showcase-card__media" href="${escapeHtml(product.url)}">
        ${image}
        ${promoBadgesMarkup(product)}
        <span class="genki-showcase-card__ribbon">${stateLabel(product)}</span>
      </a>
      <div class="genki-showcase-card__body">
        <a class="genki-showcase-card__name" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
        ${product.vendor && product.vendor !== "-" ? `<div class="genki-showcase-card__vendor">${escapeHtml(product.vendor)}</div>` : ""}
        ${releaseInfoMarkup(product)}
        ${priceMarkup(product)}
        <div class="genki-showcase-card__actions">
          <a class="genki-showcase-card__button" href="${escapeHtml(product.url)}">${escapeHtml(actionLabel(product))}</a>
        </div>
        <div class="genki-showcase-card__rating genkidama-card-rating" data-genkidama-card-rating data-product-id="${escapeHtml(product.id)}" data-product-handle="${escapeHtml(product.handle)}" aria-label="Bewertungen werden geladen"><span aria-hidden="true">☆☆☆☆☆</span></div>
      </div>
    </li>`;
  }

  async function fetchIndex(url) {
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error("Related product index not available");
    const data = await response.json();
    if (data.chunked === true) {
      if (!Array.isArray(data.chunks) || !data.chunks.length) throw new Error("Related product chunks missing");
      data.products = [];
      for (const chunkName of data.chunks) {
        const chunkResponse = await fetch(new URL(chunkName, url).toString(), { credentials: "same-origin" });
        if (!chunkResponse.ok) throw new Error("Related product chunk not available");
        const chunk = await chunkResponse.json();
        if (chunk.generated_at !== data.generated_at || !Array.isArray(chunk.products)) throw new Error("Related product chunks mismatch");
        data.products.push(...chunk.products);
      }
    }
    if (!Array.isArray(data.products) || data.products.length !== data.product_count) throw new Error("Related product count mismatch");
    return data;
  }

  function handlesFromRelated(root) {
    return Array.from(root.querySelectorAll(".product-grid .grid__item .card__heading a[href*='/products/']"))
      .map((link) => {
        const match = String(link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : "";
      })
      .filter(Boolean);
  }

  function productState(product) {
    if (product.available) return "available";
    if (product.preorder) return "preorder";
    return "soldout";
  }

  function arrayValue(value) {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  function similarityScore(product, current) {
    if (!current) return 0;
    let score = 0;
    if (product.vendor && current.vendor && product.vendor === current.vendor) score += 8;
    const productTypes = arrayValue(product.type);
    const currentTypes = arrayValue(current.type);
    if (productTypes.some((value) => currentTypes.includes(value))) score += 6;
    const productOrigins = arrayValue(product.origin);
    const currentOrigins = arrayValue(current.origin);
    if (productOrigins.some((value) => currentOrigins.includes(value))) score += 5;
    return score;
  }

  function mixedProducts(recommended, allProducts, root) {
    const limit = Math.max(4, recommended.length || 4);
    const currentId = String(root.dataset.productId || "");
    const current = allProducts.find((product) => String(product.id) === currentId);
    const poolUsed = new Set();

    function valid(product) {
      return product && product.handle && String(product.id) !== currentId;
    }

    function unique(list) {
      const output = [];
      list.forEach((product) => {
        if (!valid(product) || poolUsed.has(product.handle)) return;
        output.push(product);
        poolUsed.add(product.handle);
      });
      return output;
    }

    const basePool = unique(recommended.concat(allProducts))
      .sort((a, b) => {
        const recommendedDiff = Number(recommended.includes(b)) - Number(recommended.includes(a));
        if (recommendedDiff) return recommendedDiff;
        const scoreDiff = similarityScore(b, current) - similarityScore(a, current);
        if (scoreDiff) return scoreDiff;
        return Number(b.available || b.preorder) - Number(a.available || a.preorder);
      });

    const selected = [];
    const used = new Set();
    function add(product) {
      if (!valid(product) || used.has(product.handle)) return false;
      selected.push(product);
      used.add(product.handle);
      return true;
    }

    // Ensure the first visible row is mixed when the index has mixed stock states.
    ["available", "preorder", "soldout"].forEach((wantedState) => {
      add(basePool.find((product) => productState(product) === wantedState));
    });

    for (const product of basePool) {
      if (selected.length >= limit) break;
      add(product);
    }

    return selected.slice(0, limit);
  }

  async function enhance(root) {
    if (!root || root.dataset.genkiRelatedEnhanced === "1") return;
    const list = root.querySelector(".product-grid");
    if (!list) return;
    const handles = Array.from(new Set(handlesFromRelated(root)));
    if (!handles.length) return;
    root.dataset.genkiRelatedEnhanced = "1";

    const indexUrl = root.dataset.indexUrl;
    if (!indexUrl) return;
    const data = await fetchIndex(indexUrl);
    const allProducts = data.products || [];
    const byHandle = new Map(allProducts.map((product) => [product.handle, product]));
    const recommended = handles.map((handle) => byHandle.get(handle)).filter(Boolean);
    const products = mixedProducts(recommended, allProducts, root);
    if (!products.length) return;

    list.className = "genki-related-showcase__rail";
    list.innerHTML = products.map(renderCard).join("");
    window.GenkidamaCardRatings?.load?.(list);
  }

  function init() {
    document.querySelectorAll("[data-genki-related-products]").forEach((root) => {
      let visible = false;
      const update = () => { if (visible) enhance(root).catch(() => {}); };
      const observer = new MutationObserver(update);
      observer.observe(root, { childList: true, subtree: true });
      if ("IntersectionObserver" in window) {
        const visibility = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          visible = true;
          visibility.disconnect();
          update();
        }, { rootMargin: "200px" });
        visibility.observe(root);
      } else {
        visible = true;
        update();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
